import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import usFlag from './img/united_states.png';
import canFlag from './img/canada.png';

import useCountry from 'hooks/useCountry';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  tab: {
    background: palette.cncUI.default.primary,
    color: palette.cncUI.default['+10'],
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: 14,
    lineHeight: '16px',
    padding: '8px 4px',
    '& img, & span': {
      margin: '0 8px',
    },
    '& img': {
      marginRight: 0,
    },
    [breakpoints.only('xs')]: {
      maxWidth: 90,
    },
  },
  active: {
    background: palette.cncUI.default['+10'],
    color: palette.cncUI.default.primary,
  },
}));

const CountryTabs = props => {
  const classes = useStyles();
  const { enabled, countries, country, setCountry } = useCountry();
  const { isMobile } = props;

  if (!enabled || countries.length < 2) {
    return null;
  }

  const active = flag => country === flag;
  const imgs = { US: usFlag, CAN: canFlag };
  const labels = {
    US: isMobile ? 'US' : 'United States',
    CAN: isMobile ? 'CA' : 'Canada',
  };

  return countries.map(flag => (
    <Grid
      item
      id={`CountryTab-${flag}`}
      key={flag}
      onClick={() => setCountry(flag)}
      className={clsx(
        'country-tab',
        classes.tab,
        active(flag) && classes.active,
      )}
    >
      {active(flag) && <img src={imgs[flag]} alt={`${flag} Flag`} />}
      <span>{labels[flag]}</span>
    </Grid>
  ));
};

export default CountryTabs;
